export default __webpack_public_path__ + "static/media/330_dummy2016-kunstshop01-de.dcea797a.png";